/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPentagonNumber6 = createReactComponent(
  "pentagon-number-6",
  "IconPentagonNumber6",
  [
    [
      "path",
      {
        d: "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z",
        key: "svg-0"
      }
    ],
    [
      "path",
      {
        d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3",
        key: "svg-1"
      }
    ]
  ]
);

export { IconPentagonNumber6 as default };
//# sourceMappingURL=IconPentagonNumber6.js.map
